import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function ComingSoonPage() {
  const { lang = "ja" } = useParams();
  const { t } = useTranslation();

  return (
    <main className="relative min-h-[100vh] overflow-hidden bg-[#06121F] text-white">
      {/* Moss glow (earth tone) - v0.7.0: 0.28→0.42, 60%→65% */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at bottom, rgba(34,90,64,0.42) 0%, rgba(6,18,31,0) 65%)",
        }}
      />

      {/* Lighter veil - v0.7.0: 黒を抜く */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/10 to-black/25" />

      <div className="relative mx-auto max-w-3xl px-6 py-24 text-center">
        <div className="text-white/60 tracking-[0.18em] text-sm">
          GREAT HERO&apos;S JOURNEY
        </div>

        <h1 className="mt-6 font-serif text-4xl tracking-[0.14em] drop-shadow-[0_6px_24px_rgba(0,0,0,0.85)]">
          {t("comingSoon.heading")}
        </h1>

        <p className="mt-6 text-white/75 leading-relaxed">
          {t("comingSoon.body")}
        </p>

        <div className="mt-10">
          <Link
            to={`/${lang}`}
            className="inline-flex items-center justify-center rounded-full px-7 py-3 border border-white/50 text-white/90 backdrop-blur-sm hover:bg-white/10 transition"
          >
            {t("comingSoon.backToTop")}
          </Link>
        </div>
      </div>
    </main>
  );
}
